import { useMemo } from 'react';
import { TenantRole } from '@/api/generatedApi';
import { useTenants } from '@/services/tenants/useTenants';

export const useIndexPage = () => {
  const { tenant } = useTenants();

  const indexPagePath = useMemo(() => {
    if (!tenant?.tenantShortName) {
      return '/tenants';
    } else if (tenant.tenantRole === TenantRole.Search) {
      return `/tenants/${tenant.tenantShortName}/search`;
    } else {
      return `/tenants/${tenant.tenantShortName}/assets`;
    }
  }, [tenant]);

  return {
    indexPagePath,
  };
};
